jQuery(document).ready(function ($) {

    var hasScrolled = false;
    var header = $("#site-header");
    var headerHeigh = $("#site-header").outerHeight();
    var scrollpos = 0;
    var lastScrollTop = 0;
    $(function () {
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            var st = window.pageYOffset || document.documentElement.scrollTop;
            scrollpos = scroll;
            if (scroll >= headerHeigh) {
                if (st > lastScrollTop) {
                    header.addClass("scrolled");
                    header.removeClass("scrolled-up");
                } else {
                    header.addClass("scrolled-up");
                }

                hasScrolled = true;
            } else {
                header.removeClass("scrolled");
                hasScrolled = false;
            }
            lastScrollTop = st;
        });
    });
})
